import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddTestimonial = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr, save, update } = useService("Data", "testimonial");
  const { setTitle } = useService("Meta");
  const { showAlert, generateUID } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [content, setcontent] = useState<string>("");
  const [uid, setuid] = useState<string>("");
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [name, setname] = useState<string>("");
  const [image, setimage] = useState<string>("[]");

  const getTestimonialData = useCallback(
    async (query) => {
      const result = await fetchByAttr(query);
      if (result.status) {
        let testimonialData = result.data[0];
        setname(testimonialData.name);
        setmode("edit");
        setcontent(testimonialData.content);
        setimage(testimonialData.image);
        setuid(testimonialData.uid);
      } else showAlert({ type: "error", msg: "No testimonial added yet!" });
    },
    [fetchByAttr, showAlert]
  );

  const addTestimonial = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        testimonialObject = {
          content,
          name,
          image,
          uid: mode === "add" ? generateUID() : uid,
        };
      if (content === "") {
        errorMsg = t("errorMsg.required.content");
        error = true;
      }
      if (name === "") {
        errorMsg = t("errorMsg.required.name");
        error = true;
      }
      if (!error) {
        if (mode === "add") {
          const result = await save(testimonialObject);
          if (result.status) {
            showAlert({
              type: "success",
              msg: "Testimonial added successfully!",
            });
            navigateTo({ route: "/admin/testimonial/list" });
          } else {
            showAlert({ type: "error", msg: "Unable to add testimonial!" });
          }
        } else {
          let data = {
            query: JSON.stringify({ uid }),
            testimonialData: JSON.stringify(testimonialObject),
          };
          const result = await update(data);
          if (result.status) {
            showAlert({
              type: "success",
              msg: "Testimonial updated successfully!",
            });
            navigateTo({ route: "/admin/testimonial/list" });
          } else {
            showAlert({ type: "error", msg: "Unable to update testimonial!" });
          }
        }
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [
      content,
      generateUID,
      image,
      mode,
      name,
      navigateTo,
      save,
      showAlert,
      t,
      uid,
      update,
    ]
  );

  setTitle(t("addTestimonial"), "admin");
  const urlData = urlToSplitData(getLocationData().pathname);
  const urlMode = urlData[3];
  const urlUid = urlData[4];

  useEffect(() => {
    if (urlMode === "edit") {
      getTestimonialData({ uid: urlUid });
    }
  }, [urlMode, urlUid]);

  return {
    title: mode + " Testimonial",
    name,
    setname,
    content,
    setcontent,
    addTestimonial,
    image,
    setimage,
  };
};
